import React from 'react';
import { Container, Header, Grid, Card, Divider, List } from 'semantic-ui-react';
import '../public/css/Notes.css';

const Notes = () => (
	<Container className="notes-container" style={{ paddingBottom: '50px' }}>
		<Divider hidden />
		<Header as="h1" textAlign="center" className="notes-header">
			Notes
		</Header>
		<Divider hidden />
		<Grid divided="vertically" stackable centered>
			<Grid.Row columns={1}>
				<Grid.Column width={12}>
					<Card fluid color="blue" className="notes-card">
						<Card.Content>
							<Card.Header>Note on Transliteration:</Card.Header>
							<Card.Description>
								Transliteration follows{' '}
								<span className="text-italic">the International Journal of Middle East Studies</span>{' '}
								(IJMES) system. Names of authors display long vowels, but not diacritics. Arabic titles
								are transliterated according to Arabic convention despite the fact that the content is
								in Persian. The word <span className="text-keyword">tadhkira</span> is always translated
								as such.
							</Card.Description>
						</Card.Content>
					</Card>
					<Divider hidden />
					<Card fluid color="green" className="notes-card">
						<Card.Content>
							<Card.Header>Note on Dates:</Card.Header>
							<Card.Description>
								The completion date for a work is the last recognizable year in which a work was known
								to have been amended, rather than when an author began compiling it or its first
								appearance in manuscript form. Since Hijri dates typically yield a span of two years on
								the Gregorian calendar, the first year is used for the date that appears on the timeline
								(e.g. 1190/1776-7 -> 1776). In some cases, particularly for those{' '}
								<span className="text-keyword">tadhkiras</span> that are no longer extant, only a
								general idea of when the work was produced is known (e.g. “during the 13th/18th-19th
								century” or “first half of the 12th century”). In these cases, ranges of dates are
								provided. Per the examples listed above: ca. 1200-1300/1785-1882 and ca.
								1100-50/1688-1738.{' '}
							</Card.Description>
						</Card.Content>
					</Card>
					<Divider hidden />
					<Card fluid color="yellow" className="notes-card">
						<Card.Content>
							<Card.Header>Note on Sources:</Card.Header>
							<Card.Description>
								The major secondary sources utilized for compiling the data-set for this project (along
								with their abbreviations) are as follows:
								<br />
								<List>
									<List.Item>
										(A) Sadriddīn ʿAynī,{' '}
										<span className="text-italic">Nimūna-yi adabīyāt-i Tājīk</span>, (Moscow, 1926)
									</List.Item>
									<List.Item>
										(G) Ahmad Gulchīn-i Maʿānī,{' '}
										<span className="text-italic">Tārīkh-i tadhkira-hā-yi Fārsī</span>, 2 vols.
										(Tehran: Intishārāt-i Kitābkhānih-yi Sanāʾī, 1984-5)
									</List.Item>
									<List.Item>
										(N) Sayyid ʿAlīridā Naqavī,{' '}
										<span className="text-italic">Tadhkira-navīsī dar Hind va Pākistān</span>{' '}
										(Tehran: ʿAlī Akbar ʿIlmī, 1964)
									</List.Item>
									<List.Item>
										(S) C.A. Storey,{' '}
										<span className="text-italic">
											Persian Literature: A Bio-Bibliographical Survey
										</span>
										, vol. 1.2 (London: Luzac & Company, LTD., 1972)
									</List.Item>
									<List.Item>
										(R) Charles Rieu,{' '}
										<span className="text-italic">
											Catalogue of the Persian Manuscripts in the British Museum
										</span>
										, 3 vols. with supplement (London: British Museum, 1879-1895)
									</List.Item>
								</List>
							</Card.Description>
						</Card.Content>
					</Card>
				</Grid.Column>
			</Grid.Row>
		</Grid>
		<Divider hidden />
	</Container>
);

export default Notes;
